import { BaseService } from '../../base-service';
import { IPharmacyResidentMedications } from "./models/PharmacyResidentMedications";
import {IConfirmMedicationRequest} from "./models/IConfirmMedicationsRequest";
import { ChartDetails } from '../patientApi/models/ChartDetails';
import {MedicationInstruction} from "./models/MedicationInstruction";
import queryString from '../../queryString';
import {  PatientMedsSatusDetails } from '../patientApi/models/PatientMedsExpireDetails';
import { CourseExpiryFilterSubType } from '../patientApi/models/ExpiryFilterType';

class MedicationsApiV1 {

    async getMedications(residentAuthoringSystem: string, residentAuthoringSystemForeignKey: string,pharmacyMedicationsOrderId?:string): Promise<IPharmacyResidentMedications> {

        let path =  pharmacyMedicationsOrderId?
            `/api/v1/medications/${residentAuthoringSystem}/${residentAuthoringSystemForeignKey}/${pharmacyMedicationsOrderId}`
        :`/api/v1/medications/${residentAuthoringSystem}/${residentAuthoringSystemForeignKey}`;

        return await BaseService.AsyncGet(path);
    }

    async toggleActioned(
        residentAuthoringSystem: string,
        residentAuthoringSystemForeignKey: string,
        authoringSystem: string,
        authoringSystemForeignKey: string,
        pharmacyMedicationOrderId: string) {
        let path = '/api/v1/medications/change-status';
        return await BaseService.AsyncPost(path, {
            residentAuthoringSystem,
            residentAuthoringSystemForeignKey,
            "medicationAuthoringSystem": authoringSystem,
            "medicationAuthoringSystemForeignKey": authoringSystemForeignKey,
            pharmacyMedicationOrderId
        });
    }

    async changeMedicationPackaging(
        authoringSystem: string,
        authoringSystemForeignKey: string,
        packagingType:string) {
        let path = '/api/v1/medications/change-medication-packaging';
        return await BaseService.AsyncPost(path, {
            "medicationAuthoringSystem": authoringSystem,
            "medicationAuthoringSystemForeignKey": authoringSystemForeignKey,
            "packagingType" :packagingType
        });
    }

    async confirm(request: IConfirmMedicationRequest) {
        let path = '/api/v1/medications/confirm-medications';
        return await BaseService.AsyncPost(path, request);
    }

    async editDosageTimes(medicationAuthoringSystem:string,medicationAuthoringSystemForeignKey:string){
        return await new Promise(resolve => setTimeout(()=>resolve(true),2000));
    }
   
    async triggerMedicationSync(residentAuthoringSystem:string, residentAuthoringSystemForeignKey:string){
       
        let request =  {
            patient:{
                authoringSystem:residentAuthoringSystem, 
                authoringSystemForeignKey:residentAuthoringSystemForeignKey
            }
        }
        let path = '/api/v1/medications/trigger-medications-sync';
        return await BaseService.AsyncPost(path, request);
    }
    
}


async function getMedicationInstructions(medicationAuthoringSystem:string,medicationAuthoringSystemForeignKey:string):Promise<MedicationInstruction>{
    let url = `/api/v1/medications/${medicationAuthoringSystem}/${medicationAuthoringSystemForeignKey}/order-instruction`;
    return await BaseService.AsyncGet(url);
}

async function getChartSummary(residentAuthoringSystem: string, residentAuthoringSystemForeignKey: string):Promise<ChartDetails>{
    let path = `/api/v1/medications/${residentAuthoringSystem}/${residentAuthoringSystemForeignKey}/chart-summary`;
    return await BaseService.AsyncGet(path);
}

async function getChartContact(residentAuthoringSystem: string, residentAuthoringSystemForeignKey: string):Promise<ChartDetails>{
    let path = `/api/v1/medications/${residentAuthoringSystem}/${residentAuthoringSystemForeignKey}/chart-contact`;
    return await BaseService.AsyncGet(path);
}

async function getExpiringMedsSummary(residentAuthoringSystem: any, residentAuthoringSystemForeignKey: any, courseExpiryDateRange:CourseExpiryFilterSubType):Promise<PatientMedsSatusDetails>{
    let path = `/api/v1/medications/patient-medications-course-summary?${queryString({
        patientAuthoringSystem:residentAuthoringSystem,
        patientAuthoringSystemForeignKey:residentAuthoringSystemForeignKey,
        courseExpiryDateRange:courseExpiryDateRange
    })}`;
    let response = await BaseService.AsyncGet(path);
    return response ;
}
const medicationsService = new MedicationsApiV1();

export { medicationsService, getChartSummary,getMedicationInstructions, getExpiringMedsSummary, getChartContact };